import { BaseType, PaginationData } from '.';
import { Career } from './career';
import { File } from './file';

export const resourceTypes =  ['IMAGE', 'VIDEO', 'AUDIO', 'DOCUMENT', 'OTHER' ] as const;
export type ResourceType = (typeof resourceTypes)[number];

export interface Resource extends BaseType {
  index?: number
  careerId?: string;
  career?: Career;
  title: string
  description: string
  thumbnail: any
  resourceIds: string[];
  files?: File[];
  resourceType: ResourceType;
  resourceUrl?: string;
}

export type ResourceData = PaginationData<'data', Resource>;

export const resourceFormSchema = {
  careerId: 'string',
  resourceTitle: 'string',
  resourceDescription: 'string',
  resourceIds: ['string'],
} as const; 